import { FormikTextField } from '@cmg/design-system-formik';

import { FormFieldLayout } from '../../../../../../design-system/body-sections/form/FormFieldLayout';
import { FormLayout } from '../../../../../../design-system/body-sections/form/FormLayout';
import { INVESTOR_FIRM_DETAIL_FIELD_LABELS } from '../models/InvestorFirmDetail.model';

export function ContactInformationFields() {
  return (
    <FormLayout>
      <FormFieldLayout>
        <FormikTextField name="website1" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.website1} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="website2" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.website2} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="address1" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.address1} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="address2" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.address2} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="email1" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.email1} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="email2" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.email2} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField
          name="phoneNumber1"
          label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.phoneNumber1}
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField
          name="phoneNumber2"
          label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.phoneNumber2}
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="faxNumber1" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.faxNumber1} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="faxNumber2" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.faxNumber2} />
      </FormFieldLayout>
    </FormLayout>
  );
}
